import DashCensoEscolar from "@/Pages/CensoEscolar/index.vue";

export default [
  {
    path: "/censo-escolar/",
    name: "censo-escolar",
    component: DashCensoEscolar,
  },
];
